import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import StatisticsTable from '@app/components/shared/Statistics/Table'
import BackLink from '@app/components/ui/buttons/BackLink'
import Placeholder from '@app/components/ui/placeholders/Placeholder'
import Notice from '@app/components/ui/notifications/Notice'
import { Can } from '@app/context/ability-context'
import Olympiad from '@app/models/olympiad'
import _ from 'lodash'

const Statistics = ({ teacher, route, group, olympiad, ability, event }) => {
  if (!group || !group.object) { return null; }
  const count = _.size(group.students)

  return (
    <Fragment>
      <div className="plate-headbar">
        <BackLink to="/teachers/classes/statistics">
          TO CLASSES
        </BackLink>

        <h1 className="plate-heading plate-heading--left plate-heading--base">
          { group.object.name }
        </h1>

        <div className="h-flex-layout h-flex-layout--row-inline h-flex-layout--ai-center mb-gutter-s">
          <div className="f--md">
            { count }
            &nbsp;
            { I18n.t('teachers.show.student', {count: count}) }
            &nbsp;
          </div>
          <div className="f--md">
            { I18n.t('olympiads.grade', {grade: group.object.grade}) }
          </div>
        </div>
      </div>

      <div className="plate plate--xxl">
        { _.size(group.students) === 0 ? (
            <Placeholder>
              { I18n.t('olympic_participations.trial_stats.placeholder') }
            </Placeholder>
          ) : (
            <Fragment>
              <Can I="read trial" of="Statistic">
                <StatisticsTable
                  olympiad={olympiad}
                  group={group}
                  tasks={olympiad.trialCards}
                  event={event}
                  tour='trial'
                />
                <div className="separator" />
              </Can>

              <Can I="read preparatory" of="Statistic">
                <StatisticsTable
                  olympiad={olympiad}
                  group={group}
                  tasks={olympiad.preparatoryCards}
                  event={event}
                  tour='preparatory'
                />
              </Can>

              { !ability.can('read', 'Statistic', 'trial') && !ability.can('read', 'Statistic', 'main') && (
                  <Notice>
                    { I18n.t('olympic_participations.stats.preparatory_notification') }
                  </Notice>
                )
              }
            </Fragment>
          )
        }
      </div>
    </Fragment>
  )
}

Statistics.propTypes = {
  group: PropTypes.object.isRequired,
  olympiad: PropTypes.instanceOf(Olympiad),
  route: PropTypes.object.isRequired,
  ability: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired
}

export default Statistics
